// extracted by mini-css-extract-plugin
export default {"adminDashboard":"styles_adminDashboard__5LAoW"};